export default {
  baseUrl: 'https://bw-api.yyznmd.cn'  // 域名
};  